// EngagementDetails.jsx

// Dependencies
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import ProfileSection from '@/components/data/common/profile/ProfileSection';
import EngagementNotes from '@/components/data/engagements/EngagementNotes';
import ProfessionalEngagements from '@/components/data/professionals/ProfessionalEngagements';

const EngagementDetails = ({ engagement, professionals, startDates }) => {
  const { t } = useTranslation();

  const title = t('ENGAGEMENTS_TABLE.TITLE');
  const fields = [
    t('ENGAGEMENTS_TABLE.HEADERS.ENGAGEMENT_ID'),
    t('ENGAGEMENTS_TABLE.HEADERS.ENGAGEMENT_NAME'),
    t('ENGAGEMENTS_TABLE.HEADERS.CLIENT'),
    t('ENGAGEMENTS_TABLE.HEADERS.CLIENT_CODE'),
    t('ENGAGEMENTS_TABLE.HEADERS.TYPE'),
    t('ENGAGEMENTS_TABLE.HEADERS.STATUS'),
    t('ENGAGEMENTS_TABLE.HEADERS.MANAGER'),
    t('ENGAGEMENTS_TABLE.HEADERS.ENGAGEMENT_RC'),
    t('ENGAGEMENTS_TABLE.HEADERS.ENGAGEMENT_NOTES')
  ];
  const data = [
    engagement.EngagementID,
    engagement.EngagementName,
    engagement.Client,
    engagement.ClientCode,
    engagement.Type,
    engagement.Status,
    engagement.Manager,
    engagement.EngagementRC,
    <EngagementNotes engagementID={engagement.EngagementID} engagementNotes={engagement.EngagementNotes} />
  ];

  return (
    <div>
      <ProfileSection title={title} fields={fields} data={data} />
      {professionals && startDates && (
        <ProfessionalEngagements 
          engagements={professionals} 
          startDates={startDates} 
          isEngagementView={true}
        />
      )}
    </div>
  );
};

export default EngagementDetails;
